import { axiosPublic } from './interceptors/axios-public';
import { axiosToken } from './interceptors/axios-token';

const { VITE_API_BASE_URL, VITE_GUEST_TOKEN_URL } = typeof import.meta !== 'undefined' ? import.meta.env : process.env;

export const httpFetchGuestToken = () => {
  const url = `${VITE_GUEST_TOKEN_URL}`;
  return axiosToken({ 
    method: 'post', 
    url
  });
};

export const httpFetchVerificationDetails = token => {
   const url = `${VITE_API_BASE_URL}/verify/${token}`;
    return axiosPublic({ 
      method: 'get', 
      url 
    });
  };